'use strict'

import Vue from 'vue'
import axios from 'axios'
import store from '../store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || process.env.baseURL || process.env.apiUrl || '/api'
axios.defaults.headers.common['Content-Type'] = 'application/json'

const EXCLUDED_URL_FOR_POLLING = 'notifications'

let config = {
  withCredentials: true
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  function (config) {
    if (config.url !== EXCLUDED_URL_FOR_POLLING && !config.hideLoadingBar) {
      NProgress.start()
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

_axios.interceptors.response.use(
  function (response) {
    if (response.config && response.config.url !== EXCLUDED_URL_FOR_POLLING && !response.config.hideLoadingBar) {
      NProgress.done()
    }
    return response
  },
  function (error) {
    if (error.config && error.config.url !== EXCLUDED_URL_FOR_POLLING && !error.config.hideLoadingBar) {
      NProgress.done()
    } else if (!error.config) {
      NProgress.done()
    }

    // If its a network error, its because the server is down or 503, we assume 503.
    if (error && !error.response) {
      store.commit('setCustomErrorMsg', 'Se ha perdido la conexión.')
      store.commit('logout')
      return new Promise(() => {})
    }

    if (error && error.response && error.response.status === 401) {
      if (error.response.data) {
        if (error.response.data.detail === 'No active account found with the given credentials') {
          store.commit('setCustomErrorMsg', 'Usuario o contraseña incorrectos.')
          return new Promise(() => {})
        }
      }
      store.commit('setCustomErrorMsg', 'Su sesión ha expirado, por favor vuelva a ingresar.')
      store.commit('logout')
      return new Promise(() => {})
    }
    return Promise.reject(error)
  }
)

Plugin.install = function (Vue, options) {
  Vue.axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get () {
        return _axios
      }
    },
    $axios: {
      get () {
        return _axios
      }
    }
  })
}

Vue.use(Plugin)

export default Plugin
